import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { CounterContext } from 'context/bestContext';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';
import Empty from './components/empty';
import Cart from './components/cart';
import { StartingCostWrapper, StartingCostWrapperText } from './components/style';
import BasketOrder from './components/order';
import Currency from 'components/currency';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 120;
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  background-color: rgba(0, 0, 0, 0.8);
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
`;

const CloseWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 120;
  display: ${(props) => (props.open ? 'block' : 'none')};
`;

const BasketWrapper = styled.div`
  position: absolute;
  top: 0;
  direction: ${(props) => (props.rtlDirection ? 'rtl' : 'ltr')};
  right: ${(props) => (props.rtlDirection ? 'unset' : props.open ? '0' : '-25.924vw')};
  left: ${(props) => (props.rtlDirection ? (props.open ? '0' : '-25.924vw') : 'unset')};
  width: 25.924vw;
  height: 100vh;
  z-index: 121;
  background-color: ${(props) => (props.theme ? props.theme.cardOnCardBackground :  props.theme.primaryBackground)};
  box-shadow: ${(props) =>
    props.open ? '0 0 15px 1px rgb(94,95,98,0.3)' : '0 0 15px 1px rgb(94,95,98,0)'};
  transition: 200ms ease-in-out;
`;

function Bascket(props) {
  const { rtlDirection, theme } = useContext(ThemeContext);
  const { showBasket, setShowBasket } = useContext(CounterContext);
  const {
    checkoutInvoice,
    setCheckoutInvoice,
    basketOrders,
    getMaterialsContext,
    materials,
    loadingCreateOrder,
    // setOrderRFQ
  } = useContext(MainContext).cart;
  const { t } = useTranslation();
  useEffect(() => {
    getMaterialsContext();
  }, []);
  const { checkoutMode, invoiceId } = props;

  const checkoutOrders = checkoutInvoice.orders ? checkoutInvoice.orders : basketOrders;

  let totalPrice = 0;
  let partsNumber = 0;
  let orderObject = {};
  let colorStartingCost = {};
  let orderwithSameColorPrice = {};
  let ordersArray = [];
  let orderRFQ = false;

  const deleteInvoiceOrder = (id) => {
    let helper = { ...checkoutInvoice };
    checkoutInvoice.orders.map((basketOrder, index) => {
      if (basketOrder._id === id) {
        helper.orders.splice(index, 1);
      }
    });
    if (!helper.orders.length) {
      window.location.assign(`/dashboard`);
    }
    setCheckoutInvoice(helper);
  };
  const getStartingCost = (materialId, colorId) => {
    let result = 0;
    materials.map((material) => {
      if (material._id === materialId) {
        material.material_colors.map((color) => {
          if (color._id === colorId) {
            result = color.starting_price;
          }
        });
      }
    });
    return result;
  };
  const getOrderMaterialAndColor = (order) => {  //datas about quality are added for representing the quality options in order cart
    let materialId=order.material;
    let colorId=order.color;
    let qualityId=order.quality;
    
    let materialName = '';
    let colorName = '';
    let qualityName = '';
    let infillDesc='';
    // to handle 0 perecent infill compare with undefined
    if(order?.print_params?.infill_percentage!=undefined)
      infillDesc=`- ${order.print_params.infill_percentage}% ${t('infill')}`;
    materials.map((material) => {
      if (material._id === materialId) {
        materialName = material.name;
        material.material_colors.map((color) => {
          if (color._id === colorId) {
            colorName = color.name;
          }
        });
        material.material_qualities.map((quality) => {
          if (quality.quality._id === qualityId){
            qualityName = quality.quality.description;
          }
        });
      }
    });
    return (<>{materialName} {colorName}<br/>
            {qualityName} {infillDesc}</>);
  };
  checkoutOrders.map((order) => {
    let { color, status } = order;

    if (status === 9) {
      // setOrderRFQ(true);
      orderRFQ = true;
    }

    partsNumber += order.quantity;
    if (!orderObject[color]) {
      orderObject[color] = [
        <BasketOrder
          key={uuidv4()}
          deleteInvoiceOrder={deleteInvoiceOrder}
          invoiceId={invoiceId}
          order={order}
          getOrderMaterialAndColor={getOrderMaterialAndColor}
        />,
      ];
      orderwithSameColorPrice[color] = order.price;
      colorStartingCost[color] = getStartingCost(order.material, color);
    } else {
      orderObject[color].push(
        <BasketOrder
          key={order._id}
          deleteInvoiceOrder={deleteInvoiceOrder}
          invoiceId={invoiceId}
          order={order}
          getOrderMaterialAndColor={getOrderMaterialAndColor}
        />
      );
      orderwithSameColorPrice[color] += order.price;
    }
  });

  for (let key in orderObject) {
    totalPrice += Math.max(orderwithSameColorPrice[key], colorStartingCost[key]);
    if (colorStartingCost[key] === 0) {
      ordersArray = [ordersArray, ...orderObject[key]];
    } else {
      ordersArray.push(
        <StartingCostWrapper theme={theme}>
          {orderObject[key]}
          <StartingCostWrapperText rtlDirection={rtlDirection} theme={theme} bottom="5.622vw">
            <div>{t('cart.material.Minimum cost')}</div>
            <Currency value={colorStartingCost[key]} />
          </StartingCostWrapperText>
          <StartingCostWrapperText rtlDirection={rtlDirection} theme={theme} bottom="4.216vw">
            <div>{t('cart.material.Additional cost')}</div>
            <Currency
              value={
                colorStartingCost[key] - orderwithSameColorPrice[key] > 0
                  // ? colorStartingCost[key] - orderwithSameColorPrice[key]  this is changed to below one by qazal instead of the above line for preventing of floating point
                  ? (Number.isInteger(colorStartingCost[key] - orderwithSameColorPrice[key]) ? (colorStartingCost[key] - orderwithSameColorPrice[key]) : parseFloat( colorStartingCost[key] - orderwithSameColorPrice[key] ).toFixed(2))
                  : 0
              }
            />
          </StartingCostWrapperText>
          <StartingCostWrapperText rtlDirection={rtlDirection} theme={theme} bottom="1.197vw">
            <div>{t('cart.material.The total cost of this material')}</div>
            <Currency
              value={parseFloat(
                Math.max(orderwithSameColorPrice[key], colorStartingCost[key])
              ).toFixed(2)}
            />
          </StartingCostWrapperText>
        </StartingCostWrapper>
      );
    }
  }

  return (
    <>
      {checkoutMode ? (
        <Cart
          totalPrice={totalPrice}
          partsNumber={partsNumber}
          display={checkoutOrders.length !== 0}
          ordersArray={ordersArray}
          setShowBasket={setShowBasket}
          checkoutMode={checkoutMode}
          orderRFQ={orderRFQ}
        />
      ) : (
        <Wrapper open={showBasket}>
          <CloseWrapper open={showBasket} onClick={() => setShowBasket(false)} />
          <BasketWrapper open={showBasket} theme={theme} rtlDirection={rtlDirection}>
            <Empty display={checkoutOrders.length === 0 && !loadingCreateOrder} />
            <Cart
              totalPrice={totalPrice}
              orderRFQ={orderRFQ}
              partsNumber={partsNumber}
              display={checkoutOrders.length !== 0 || loadingCreateOrder}
              ordersArray={ordersArray}
              setShowBasket={setShowBasket}
              loadingCreateOrder={loadingCreateOrder}
            />
          </BasketWrapper>
        </Wrapper>
      )}
    </>
  );
}

export default Bascket;
